// import React, { useState, useEffect } from "react";
// import {
//   Alert,
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Form,
//   CardHeader,
// } from "@mui/material";
// import { Formik } from "formik";
// import SelectBox from "../../common/coreComponents/select";
// import InputButton from "../../common/coreComponents/inputButton";
// import InputBox from "../../common/coreComponents/inputBox";
// import MultipleSelectChip from "../../common/coreComponents/selectchip";
// import Toggle from "../../common/coreComponents/toggle";
// import {
//   addCovidData,
//   updateCovidData,
// } from "../../services/covidReportServices";
// import { covidVaccinationSchema } from "../../validation/validation";

// import Checkbox from "@mui/material/Checkbox";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
// import classNames from "classnames";

// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const styles = (theme) => ({
//   textField: {
//     width: "90%",
//     marginLeft: "auto",
//     marginRight: "auto",
//     paddingBottom: 0,
//     marginTop: 0,
//     fontWeight: 500,
//   },
//   input: {
//     color: "red",
//   },
// });
// function CovidVaccinationReport({ editData, setOpen }) {
//   // const [report, setReport] = useState(false);
//   const [sanitized, setSanitized] = useState([
//     { label: "Yes", value: "yes" },
//     { label: "No", value: "no" },
//   ]);
//   const [premedicalListSelect, setpremedicalListSelect] = useState([
//     { title: "Diabetes", value:"diabetes" },
//     { title: "Heart disease" },
//     { title: "Chronic Lung disease: Part II" },
//     { title: "Chronic kidney disease" },
//     { title: "Overweight obesity" },
//     { title: "Hypertension" },
//     { title: "Cancer" },
//   ]);
//   const [result, setResult] = useState([
//     { label: "Positive", value: "positive" },
//     { label: "Negative", value: "negative" },
//   ]);
//   const [saturation, setSaturation] = useState([
//     { label: "Greater than 100%", value: "true" },
//     { label: "Less than 90%", value: "false" },
//   ]);
//   const isEdit = editData && editData._id;
//   // Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
//   // const top100Films = [
//   //   { title: "diabetes"},
//   //   { title: "Heart disease" },
//   //   { title: "Chronic Lung disease: Part II" },
//   //   { title: "Chronic kidney disease" },
//   //   { title: "Overweight obesity" },
//   //   { title: "Hypertension" },
//   //   { title: "Cancer"},
//   // ];

//   const mappingProp = [
//     { form: "premedical", server: "premedicalcondition" },
//     { form: "report", server: "rtpcrReport" },
//     { form: "date", server: "rtpcrReportDate" },
//     { form: "result", server: "result" },
//     { form: "lastdate", server: "rtpcrLastDate" },
//     { form: "saturation", server: "oxygensaturation" },
//     { form: "temperature", server: "temperature" },
//     { form: "sanitized", server: "sanitized" },
//     { form: "firstdose", server: "firstDose" },
//     { form: "seconddose", server: "secondDose" },
//   ];

//   if (editData) {
//     for (let i = 0; i < mappingProp.length; i++) {
//       const _el = mappingProp[i];
//       editData[_el.form] = editData[_el.server];
//     }
//   }

//   async function saveCovidReport(covidReportDetails) {
//     try {
//       let covidReportData = {
//         premedicalcondition: covidReportDetails.premedical,
//         rtpcrReport: covidReportDetails.report,
//         rtpcrReportDate: covidReportDetails.date,
//         result: covidReportDetails.result,
//         rtpcrLastDate: covidReportDetails.lastdate,
//         oxygensaturation: covidReportDetails.saturation,
//         temperature: covidReportDetails.temperature,
//         sanitized: covidReportDetails.sanitized,
//         firstDose: covidReportDetails.firstdose,
//         secondDose: covidReportDetails.seconddose,
//       };

//       let result = {};
//       if (formData._id) {
//         //call edit/update API
//         result = await updateCovidData(formData._id, {
//           ...covidReportData,
//           // _id: formData._id,
//         });
//       } else {
//         //call Save API
//         result = await addCovidData(covidReportData);
//       }
//       if (result.status === 200) {
//         setOpen(false);
//       }
//     } catch (e) {}
//   }

//   const [formData, setFormData] = useState(
//     editData
//       ? {
//           ...editData,
//         }
//       : {
//           premedical: [],
//           report: "",
//           date: "",
//           result: "",
//           lastdate: "",
//           saturation: "",
//           temperature: "",
//           sanitized: "",
//           firstdose: "",
//           seconddose: "",
//           // status: "",
//         } //initial form data
//   );

//   return (
//     <div>
//       <Container fluid className="px-0 ">
//         <Row>
//           <Col className="mx-16 mt-4">
//             <Card small className="mb-6">
//               <CardHeader className="border-bottom">
//                 <h6 className="m-0 mainheader">
//                   {isEdit ? "Edit" : "Add"}Covid Vaccination Report
//                 </h6>
//               </CardHeader>
//               <CardBody className="p-0">
//                 <Form className="py-6">
//                   <CardBody className="p-0">
//                     <Formik
//                       initialValues={formData}
//                       onSubmit={(values) => {
//                         saveCovidReport(values);
//                       }}
//                       // validationSchema={covidVaccinationSchema}
//                     >
//                       {({
//                         handleSubmit,
//                         values,
//                         handleChange,
//                         touched,
//                         errors,
//                       }) => (
//                         <>
//                           <Row form className="mx-4">
//                             <Col
//                               md="12"
//                               className="form-group mainheader"
//                             ></Col>
//                             <Col md="12" className="form-group">
//                               <label className="subheader" htmlFor="premedical">
//                                 Pre-Existing Medical Conditions
//                               </label>
//                               <Autocomplete
//                                 multiple
//                                 id="premedical"
//                                 name="premedical"
//                                 options={premedicalListSelect}
//                                 // value={"p"}
//                                 disableCloseOnSelect
//                                 getOptionLabel={(option) => option.title}
//                                 renderOption={(props, option, { selected }) => (
//                                   <li {...props}>
//                                     <Checkbox
//                                       icon={icon}
//                                       checkedIcon={checkedIcon}
//                                       style={{ marginRight: 8 }}
//                                       checked={selected}
//                                     />
//                                     {option.title}
//                                   </li>
//                                 )}
//                                 style={{ width: 500 }}
//                                 onChange={handleChange}
//                                 renderInput={(params) => (
                                  
//                                   <TextField
//                                     {...params }
//                                     label="Pre-medical"
//                                     placeholder="Select"
//                                     className={styles.textField}
//                                     //   InputProps={{
//                                     //     className: styles.input,
//                                     // }}
//                                   />
//                                 )}
//                               />
//                               {/* 
//                               <MultipleSelectChip
//                                 list={premedicalListSelect}
//                                 name="premedical"
//                                 value={values.premedical}
//                                 onChange={(e) => {
//                                   setpremedicalListSelect(e);
//                                 }}
//                               />
//                               {touched.premedical && errors.premedical ? (
//                                 <div className="errorMessage">
//                                   {errors.premedical}
//                                 </div>
//                               ) : null} */}
//                             </Col>
//                             <Col md="12" className="form-group">
//                               <label className="subheader" htmlFor="Status">
//                                 {" "}
//                                 RT-PCR Report
//                               </label>
//                               <Toggle
//                                 name="report"
//                                 value={values.report}
//                                 onChange={(e) => {
//                                   handleChange({
//                                     target: {
//                                       name: "report",
//                                       value: e.target.checked,
//                                     },
//                                   });
//                                 }}
//                               />
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="date">
//                                 RT-PCR Date
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <InputBox
//                                 id="date"
//                                 name="date"
//                                 type="date"
//                                 placeholder="Enter Date"
//                                 value={values.date}
//                                 className=""
//                                 onChange={handleChange}
//                               />
//                               {touched.date && errors.date ? (
//                                 <div className="errorMessage">
//                                   {errors.date}
//                                 </div>
//                               ) : null}
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="result">
//                                 RT-PCR Result
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <SelectBox
//                                 className=""
//                                 options={result}
//                                 onChange={(d) => {
//                                   handleChange(d);
//                                 }}
//                                 name="result"
//                                 value={values.result}
//                                 id="result"
//                                 errorMessage=""
//                                 placeholder="Select Result"
//                               />
//                               {touched.result && errors.result ? (
//                                 <div className="errorMessage">
//                                   {errors.result}
//                                 </div>
//                               ) : null}
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="date">
//                                 RT-PCR Last-Date
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <InputBox
//                                 id="lastdate"
//                                 name="lastdate"
//                                 type="date"
//                                 placeholder="Enter Date"
//                                 value={values.lastdate}
//                                 className=""
//                                 onChange={handleChange}
//                               />
//                               {touched.lastdate && errors.lastdate ? (
//                                 <div className="errorMessage">
//                                   {errors.lastdate}
//                                 </div>
//                               ) : null}
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="saturation">
//                                 Oxygen Saturation
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <SelectBox
//                                 className=""
//                                 options={saturation}
//                                 onChange={(d) => {
//                                   handleChange(d);
//                                 }}
//                                 name="saturation"
//                                 value={values.saturation}
//                                 id="saturation"
//                                 errorMessage=""
//                                 placeholder="Select"
//                               />
//                               {touched.saturation && errors.saturation ? (
//                                 <div className="errorMessage">
//                                   {errors.saturation}
//                                 </div>
//                               ) : null}
//                             </Col>
//                             <Col md="12" className="form-group subheader">
//                               Daily Task
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="temperature">
//                                 Body Temperature
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <InputBox
//                                 id="temperature"
//                                 name="temperature"
//                                 type="temperature"
//                                 placeholder="Enter Temperature"
//                                 value={values.temperature}
//                                 className=""
//                                 onChange={handleChange}
//                               />
//                               {touched.temperature && errors.temperature ? (
//                                 <div className="errorMessage">
//                                   {errors.temperature}
//                                 </div>
//                               ) : null}
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="sanitized">
//                                 Sanitized
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <SelectBox
//                                 className=""
//                                 options={sanitized}
//                                 onChange={(d) => {
//                                   handleChange(d);
//                                 }}
//                                 name="sanitized"
//                                 value={values.sanitized}
//                                 id="sanitized"
//                                 errorMessage=""
//                                 placeholder="Select"
//                               />
//                               {touched.sanitized && errors.sanitized ? (
//                                 <div className="errorMessage">
//                                   {errors.sanitized}
//                                 </div>
//                               ) : null}
//                             </Col>
//                             <Col md="12" className="form-group subheader">
//                               Vaccination Information
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="firstdose">
//                                 First Dose
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <InputBox
//                                 id="firstdose"
//                                 name="firstdose"
//                                 type="date"
//                                 placeholder="Enter Date"
//                                 value={values.firstdose}
//                                 className=""
//                                 onChange={handleChange}
//                               />
//                               {touched.firstdose && errors.firstdose ? (
//                                 <div className="errorMessage">
//                                   {errors.firstdose}
//                                 </div>
//                               ) : null}
//                             </Col>
//                             <Col md="5" className="form-group">
//                               <label htmlFor="seconddose">
//                                 Second Dose
//                                 <span style={{ color: "red" }}>*</span>
//                               </label>
//                               <InputBox
//                                 id="seconddose"
//                                 name="seconddose"
//                                 type="date"
//                                 placeholder="Enter Date"
//                                 value={values.seconddose}
//                                 className=""
//                                 onChange={handleChange}
//                               />
//                               {touched.seconddose && errors.seconddose ? (
//                                 <div className="errorMessage">
//                                   {errors.seconddose}
//                                 </div>
//                               ) : null}
//                             </Col>
//                           </Row>
//                           <Row className="flex-row-reverse mx-4 my-4">
//                             <InputButton
//                               id="submitBtn"
//                               type="submit"
//                               className="odd-submit-btn"
//                               children="Submit"
//                               startIcon={""}
//                               onClick={handleSubmit}
//                             />
//                           </Row>
//                         </>
//                       )}
//                     </Formik>
//                   </CardBody>
//                 </Form>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// }
// export default CovidVaccinationReport;


import React, { useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Autocomplete,
  Checkbox,
} from "@mui/material";

import InputButton from "../../../components/common components/toggle";
import { Formik } from "formik";
// import { covidVaccinationSchema } from "../../validation/validation";

const CovidVaccinationReport = ({ editData, setOpen }) => {
  const [sanitized, setSanitized] = useState([
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ]);

  const [premedicalListSelect, setPremedicalListSelect] = useState([
    { title: "Diabetes", value: "diabetes" },
    { title: "Heart disease", value: "heartDisease" },
    { title: "Chronic Lung disease: Part II", value: "chronicLungDisease" },
    { title: "Chronic kidney disease", value: "chronicKidneyDisease" },
    { title: "Overweight obesity", value: "overweightObesity" },
    { title: "Hypertension", value: "hypertension" },
    { title: "Cancer", value: "cancer" },
  ]);

  const [result, setResult] = useState([
    { label: "Positive", value: "positive" },
    { label: "Negative", value: "negative" },
  ]);

  const [saturation, setSaturation] = useState([
    { label: "Greater than 100%", value: "true" },
    { label: "Less than 90%", value: "false" },
  ]);

  const isEdit = editData && editData._id;

  const saveCovidReport = async (covidReportDetails) => {
    try {
      let covidReportData = { ...covidReportDetails };
      let result = {};
      if (formData._id) {
        result = []
          // await updateCovidData(formData._id, covidReportData);
      } else {
        result =[]
          // await addCovidData(covidReportData);
      }
      if (result.status === 200) {
        setOpen(false);
      }
    } catch (e) {
      console.error("Error:", e);
    }
  };

  const [formData, setFormData] = useState(
    editData
      ? {
          ...editData,
        }
      : {
          premedical: [],
          report: "",
          date: "",
          result: "",
          lastdate: "",
          saturation: "",
          temperature: "",
          sanitized: "",
          firstdose: "",
          seconddose: "",
        }
  );

  return (
    <Container fluid className="px-0">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card sx={{ mb: 6 }}>
            <CardHeader className="border-bottom">
              <h6 className="m-0 mainheader">
                {isEdit ? "Edit" : "Add"} Covid Vaccination Report
              </h6>
            </CardHeader>
            <CardContent className="p-0">
              <Formik
                initialValues={formData}
                onSubmit={(values) => saveCovidReport(values)}
                validationSchema={covidVaccinationSchema}
              >
                {({ handleSubmit, values, handleChange, touched, errors }) => (
                  <form onSubmit={handleSubmit} className="py-6">
                    <CardContent className="p-0">
                      <Grid container spacing={2} className="mx-4">
                        <Grid item xs={12} md={12} className="form-group">
                          <label className="subheader" htmlFor="premedical">
                            Pre-Existing Medical Conditions
                          </label>
                          <Autocomplete
                            multiple
                            id="premedical"
                            name="premedical"
                            options={premedicalListSelect}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.title}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox
                                  icon={
                                    <CheckBoxOutlineBlankIcon fontSize="small" />
                                  }
                                  checkedIcon={
                                    <CheckBoxIcon fontSize="small" />
                                  }
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option.title}
                              </li>
                            )}
                            style={{ width: 500 }}
                            onChange={handleChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Pre-medical"
                                placeholder="Select"
                              />
                            )}
                          />
                        </Grid>
                        {/* Other form fields */}
                      </Grid>
                      <Grid
                        container
                        justifyContent="flex-end"
                        className="mx-4 my-4"
                      >
                        <Grid item>
                          <InputButton
                            id="submitBtn"
                            type="submit"
                            className="odd-submit-btn"
                            children="Submit"
                            onClick={handleSubmit}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </form>
                )}
              </Formik>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CovidVaccinationReport;
